import { NgClass, NgFor } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, effect, forwardRef, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { AdvancedCommerceSearchStore, AdvancedCommerceStore } from '@df/module-advanced-commerce';
import { HrefComponent } from '@df/ui/common/href/href.component';
import { SizeClassDirective } from '@df/ui/common/size-class.directive';
import { getState } from '@ngrx/signals';
import { ProductComponent } from 'projects/app-default/src/app/catalog/ui/product/product.component';
import { GtmImpressionTrackDirective } from '../../../../gtm/gtm-impression-track.directive';
import { GtmTrackProductClickDirective } from '../../../../gtm/gtm-track-product-click.directive';

export interface ISearchesTextItem {
    text: string;
    link: string;
}
export interface ITrendingNowItem extends ISearchesTextItem {
    image: string;
    link_text: string;
}

@Component({
    selector: 'advanced-commerce-search-outlet-no-results',
    templateUrl: './advanced-commerce-search-outlet-no-results.html',
    standalone: true,
    imports: [
        GtmImpressionTrackDirective,
        GtmTrackProductClickDirective,
        HrefComponent,
        NgClass,
        NgFor,
        forwardRef(() => ProductComponent),
        RouterLink,
        SizeClassDirective
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AdvancedCommerceSearchOutletNoResultsComponent {
    readonly searchStore = inject(AdvancedCommerceSearchStore);
    private changeDetectorRef = inject(ChangeDetectorRef);

    constructor() {
        // hack for detect changes in signals store
        effect(() => {
            // read store changes and update template
            const state = getState(this.searchStore);

            this.changeDetectorRef.detectChanges();
        });
    }

    get popularSearches(): string[] {
        return this.searchStore.searchPopularSearches()?.items?.slice(0, 5);
    }
    get popularSearchesTitle(): string {
        return this.searchStore.searchPopularSearches()?.label;
    }

    get additionalTitle(): string {
        return this.searchStore.searchHelp()?.label;
    }
    get additionalItems(): ISearchesTextItem[] {
        return this.searchStore.searchHelp()?.items;
    }

    get trendingNowTitle(): string {
        return this.searchStore.noResultsItemsEntities()?.length > 0
            ? this.searchStore.searchNoResults()?.label
            : this.searchStore.searchHeadings()?.['home_products'];
    }

    get trendingNowItems(): AdvancedCommerceStore.Items.Item[] {
        return (
            this.searchStore.noResultsItemsEntities()?.length > 0
                ? this.searchStore.noResultsItemsEntities()
                : this.searchStore.homeRecsItemsEntities()?.length > 0
                  ? this.searchStore.homeRecsItemsEntities()
                  : this.searchStore.itemsEntities()
        )?.slice(0, 3);
    }
}
